export default __webpack_public_path__ + "static/media/ic_location_on_blue_48px.6c769d32.svg";